import type { FormStepId } from 'shared/config/formStepId';
import type { IInitialEvent } from 'shared/lib/sendGAEvents';

import { sendStepsAnalyticsEvents } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';
import { ContactsInfoTexts } from 'features/UpdateContactsInfo';
import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo';
import { PassportInfoTexts } from 'features/UpdatePassportInfo';
import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

export const validateSuccessHandlerThunk =
  (
    validatedSteps: Array<ValuesOf<typeof FormStepId>>,
    analyticsOverrides?: Partial<Pick<IInitialEvent, 'event' | 'eventCategory'>>,
  ): ThunkResult<void> =>
  async (dispatch) => {
    if (validatedSteps.length) {
      dispatch(
        sendStepsAnalyticsEvents(
          Array.from({ length: validatedSteps.length }, (_, i) => i),
          {
            ...CreditPurposeInfoTexts,
            ...ContactsInfoTexts,
            ...PassportInfoTexts,
            ...WorkplaceInfoTexts,
            ...AdditionalInfoTexts,
          },
          'auto',
          analyticsOverrides,
        ),
      );
    }
  };
